import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';

import ActionFieldItem from '@common/ActionButtons/ActionFieldItem';
import DeleteIcon from '@assets/icons/delete.svg';
import AutocompleteWithPagination from '@common/AutocompleteWithPagination/AutocompleteWithPagination';

import useStyles from '../styles';

const CompaniesDropDawn = ({ removeFilter, data, index }) => {
  const classes = useStyles();

  return (
    <div className={classes.companiesDropDawn}>
      <Field
        name={`crmCompanies[${index}].companyIds`}
        id="companyIds"
        size="small"
        showLabel
        render={props => (
          <AutocompleteWithPagination
            {...props}
            classNameWrapper={classes.input}
            multiple
            renderTags={selected => (
              <div className={classes.selected}>
                {`Selected: ${selected.length}`}
              </div>
            )}
          />
        )}
        resource={`/Integration/companies/${data.id}/v2`}
      />
      <ActionFieldItem
        handler={() => removeFilter(index)}
        toolTip="Delete"
        icon={DeleteIcon}
        classNameWrapper={classes.deleteButton}
      />
    </div>
  );
};

CompaniesDropDawn.propTypes = {
  removeFilter: PropTypes.func,
  index: PropTypes.number,
  data: PropTypes.shape({
    id: PropTypes.number,
    crmType: PropTypes.string,
  }),
};

export default memo(CompaniesDropDawn);
